import { render } from "./TabContainer.vue?vue&type=template&id=2780048d"
import script from "./TabContainer.vue?vue&type=script&lang=js"
export * from "./TabContainer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/TabContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2780048d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2780048d', __exports__)) {
    console.log('reload')
    api.reload('2780048d', __exports__)
  }
  
  module.hot.accept("./TabContainer.vue?vue&type=template&id=2780048d", () => {
    console.log('re-render')
    api.rerender('2780048d', render)
  })

}


export default __exports__